<template>
  <b-card>
    <validation-observer ref="simpleRules">
      <b-form>
        <!-- Section Informations -->
        <h4>{{$t('Asset Model Limits')}}</h4>
        <span class="font-weight-bold">{{$t('The fields with (*) are required')}}</span>
        <hr class="mb-2">
        
        <b-row>
          <!-- Field: Asset Model -->
          <b-col  cols="12" md="4">
            <b-form-group :label="$t('Asset Model')" label-for="model">
              <vue-autosuggest v-if="!modelLimitData.id" v-model="search" :suggestions="filteredOptions" :input-props="inputProps" @selected="selectHandler" @input="onInputChange">
                <template slot-scope="{suggestion}">
                  <span class="my-suggestion-item">{{ suggestion.item.name }}</span>
                </template>
              </vue-autosuggest>

              <b-form-input v-if="modelLimitData.id" id="customer" v-model="search" disabled />
            </b-form-group>
          </b-col>

          <!-- Field: AlertType -->
          <b-col cols="12" md="4">
            <b-form-group :label="$t('Alert Type') + '*'" label-for="alert">
              <v-select :disabled="isEditing" v-model="modelLimitData.alertTypeId" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="alertOptions" :reduce="val => val.value" :clearable="true" input-id="alert" />
            </b-form-group>
          </b-col>

          <!-- Field: limitType -->
          <b-col cols="12" md="4">
            <b-form-group :label="$t('Limit Type') + '*'" label-for="limit">
              <v-select :disabled="isEditing" v-model="modelLimitData.limitTypeId" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="limitOptions" :reduce="val => val.value" :clearable="true" input-id="limit" />
            </b-form-group>
          </b-col>
        </b-row>
        
        <b-row>
          <!-- Field: telemetry -->
          <b-col cols="12" md="4">
            <b-form-group :label="$t('Telemetry parameter name') + '*'" label-for="telemetry">
              <validation-provider #default="{ errors }" name="telemetry" rules="required">
                <b-form-input :disabled="isEditing" id="telemetry" v-model="modelLimitData.telemetryParameterName" :placeholder="$t('Telemetry parameter example')"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group :label="$t('Limit value') + '*'" label-for="value">
              <validation-provider #default="{ errors }" name="value" rules="required">
                <b-form-input id="telemetry" v-model="modelLimitData.value" :placeholder="$t('Limit value example')"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="!user.role.endsWith('VI')" cols="12">
            <b-button variant="primary" type="submit" @click.prevent="validationForm">
              {{$t('Save')}}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>


<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BAvatar,
  BBadge,
  BPagination,
  BCardBody,
  BCardHeader,
  BSpinner,
  BFormGroup,
  BAlert,
  VBTooltip, BForm
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {computed, onMounted, onUnmounted, ref} from '@vue/composition-api'
import i18n from '@/libs/i18n'
import store from '@/store'
import {VueAutosuggest} from 'vue-autosuggest'
import assetStoreModule from "@/views/main/asset/assetStoreModule";
import assetModelLimitStoreModule from "@/views/main/asset-model-limit/assetModelLimitStoreModule";
import router from "@/router";
import {
  ValidationProvider,
  ValidationObserver
} from 'vee-validate'
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from '@validations'

export default {
  components: {
    BForm,
    BAlert,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BAvatar,
    BBadge,
    BPagination,
    BCardBody,
    BCardHeader,
    BSpinner,
    vSelect,
    VueAutosuggest,
    ValidationProvider,
    ValidationObserver
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data(){
    return {
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
    }
  },
  computed:{
    isEditing() {
      return !!this.modelLimitData.id;
    }
  },
  methods: {
    async validationForm() {
      const isValid = await this.$refs.simpleRules.validate();
      if (!isValid) return;

      try {
        await this.submitAssetModelLimit();
        this.handlePostSubmitSuccess();
      } catch (error) {
        const errorMsg = this.isEditing ? 'FAILURE to update' : 'Failed to save';
        this.msgDialog(this.$t(errorMsg), 'error');
      }
    },
    async submitAssetModelLimit() {
      const actionName = this.isEditing
          ? 'updateAssetModelLimit'
          : 'addAssetModelLimit';

      const storeAction = `${this.ASSET_MODEL_LIMITS_APP_STORE_MODULE_NAME}/${actionName}`;

      const payload = {
        modelLimitData: this.modelLimitData
      };

      return store.dispatch(storeAction, payload);
    },
    handlePostSubmitSuccess() {
      const successMsg = this.isEditing ? 'Successful update' : 'Successful registration';
      this.msgDialog(this.$t(successMsg), 'success');

      if (this.isEditing) {
        window.location.reload();
      } else {
        router.push({ name: 'list-model-limit' });
      }
    },
    msgDialog(msg, icon) {
      this.$swal({
        position: 'top-end',
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 1500 * 3,
        customClass: {
          confirmButton: 'btn btn-primary',
        },

        buttonsStyling: false,
      })
    },
    
  },
  setup(props, {emit}) {
    const ASSET_MODEL_LIMITS_APP_STORE_MODULE_NAME = 'app-asset-model-limit'
    const ASSET_APP_STORE_MODULE_NAME = 'app-asset'
    const user = localStorage.userData != undefined ? JSON.parse(localStorage.userData) : {}
    const limitOptions = ref([{label: '', value: ''}])
    const alertOptions = ref([{label: '', value: ''}])
    const search = ref('')
    const filteredOptions = ref([])
    const inputProps = computed(() => ({
      id: 'autosuggest__input',
      class: 'form-control',
      placeholder: i18n.t('Auto Complete'),
    }))
    const modelLimitData = ref({
      id: '',
      assetModelId: '',
      alertTypeId: '',
      limitTypeId: '',
      telemetryParameterName: '',
      value: ''
    })
    

    if (!store.hasModule(ASSET_APP_STORE_MODULE_NAME)) {
      store.registerModule(ASSET_APP_STORE_MODULE_NAME, assetStoreModule)
    }
    if (!store.hasModule(ASSET_MODEL_LIMITS_APP_STORE_MODULE_NAME)) {
      store.registerModule(ASSET_MODEL_LIMITS_APP_STORE_MODULE_NAME, assetModelLimitStoreModule)
    }

    onUnmounted(() => {
      if (store.hasModule(ASSET_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(ASSET_APP_STORE_MODULE_NAME)
      }
      if (store.hasModule(ASSET_MODEL_LIMITS_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(ASSET_MODEL_LIMITS_APP_STORE_MODULE_NAME)
      }
    })

    const populateLimits = () => {
      // Fetch AssetModelLimitsType
      store.dispatch(`${ASSET_MODEL_LIMITS_APP_STORE_MODULE_NAME}/fetchLimits`)
          .then(response => {
            response.data.data.forEach(limit => {
              limitOptions.value.push({
                label: limit.name,
                value: limit.id
              })
            })
          })
          .catch(() => {})
    }

    const populateAlerts = () => {
      // Fetch AssetModelLimitsType
      store.dispatch(`${ASSET_MODEL_LIMITS_APP_STORE_MODULE_NAME}/fetchAlerts`)
          .then(response => {
            response.data.data.forEach(alert => {
              alertOptions.value.push({
                label: alert.name,
                value: alert.id
              })
            })
          })
          .catch(() => {})
    }

    
    const selectHandler = (option) => {
      filteredOptions.value = []
      modelLimitData.value.assetModelId = option.item.id
      search.value = option.item.name
    }
    
    const onInputChange = (text) =>{
      if(!text || text.length < 3){
        search.value = ''
        filteredOptions.value = []
        return
      }
      store.dispatch(`${ASSET_APP_STORE_MODULE_NAME}/fetchAssetsModel`, {id: '', page: 1, perPage: 5, search: text})
          .then(response => {
            filteredOptions.value = [{
              data: response.data.data,
            }]
          })
          .catch(() => {})
    }
    
    const needFetchAssetModelLimit = () => {
      if(router.currentRoute.params.id){
        fetchAssetModelLimit()
      }
    }
    
    const fetchAssetModelLimit = () => {
      store.dispatch(`${ASSET_MODEL_LIMITS_APP_STORE_MODULE_NAME}/fetchAssetModelLimit`, {
        id: router.currentRoute.params.id
      })
          .then(response => {
            modelLimitData.value = response.data
            search.value = response.data.assetModelName
           
          })
          .catch(() => {})
    }

    onMounted(() => {
      populateLimits()
      populateAlerts()
      needFetchAssetModelLimit()
    })
    
    return{
      ASSET_MODEL_LIMITS_APP_STORE_MODULE_NAME,
      user,
      limitOptions,
      alertOptions,
      filteredOptions,
      search,
      inputProps,
      modelLimitData,
      populateLimits,
      populateAlerts,
      selectHandler,
      onInputChange,
      fetchAssetModelLimit
    }


  }
}

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-autosuggest.scss';
</style>